export default __webpack_public_path__ + "media/main_banner_mobile.712d07e6.png";